import { Component, Input } from '@angular/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { GwrWohnungListEntry, Stockwerk } from '../../../core/gwr-api';
import { ComparatorService } from '../../../shared/services/comparator-service';
import { AbstractComponent } from '../../../shared/components/abstract-component/abstract.component';
import { ListLoader } from '../../../shared/components/list-loader/list-loader';
import { TableSortModel } from '../../../shared/tablesort/tableSortModel';
import { ListLoaderWrapperComponent } from '../../../shared/components/list-loader-wrapper/list-loader-wrapper.component';
import { NgTemplateOutlet } from '@angular/common';
import { ColumnHeaderComponent } from '../../../shared/tablesort/sort-icon/column-header.component';
import { LinkComponent } from '../../../shared/components/link/link.component';
import { TranslatePipe } from '@ngx-translate/core';
import { KompaktGwrGebaeudeeingangsadressePipe } from '../../gwr-gebaeude/kompakt-gebaeudeeingangsadresse-pipe';

@Component({
  selector: 'cap-gwr-wohnung-table',
  templateUrl: './gwr-wohnung-table.component.html',
  styleUrls: ['./gwr-wohnung-table.component.scss'],
  imports: [
    ListLoaderWrapperComponent,
    NgTemplateOutlet,
    ColumnHeaderComponent,
    LinkComponent,
    TranslatePipe,
    KompaktGwrGebaeudeeingangsadressePipe
  ]
})
export class GwrWohnungTableComponent extends AbstractComponent {
  private _listLoader: ListLoader<GwrWohnungListEntry>;

  tableSortModel = new TableSortModel<GwrWohnungListEntry>('table', this.comparatorService);

  constructor(private comparatorService: ComparatorService) {
    super();
    keysToTranslate<string>(['Wohnungen', 'AnzeigeWohnung', 'LageStockwerk', 'AdminNr', 'AdresseEingang']);
    keysToTranslate<Stockwerk.StockwerkBezeichnungEnum>(['PARTERRE', 'STOCK', 'UNTERGESCHOSS']);
    this.tableSortModel
      .addColumn('ewid', (a, b) => this.comparatorService.orderByComparator(a.ewid.value, b.ewid.value), undefined)
      .switchSortDirection();
    this.tableSortModel.addColumn(
      'adresse',
      (a, b) => this.comparatorService.gebaeudeEingangAdresseComparator(a.adresse, b.adresse),
      undefined
    );
    this.tableSortModel.addColumn(
      'wohnungsstatus',
      (a, b) => this.comparatorService.orderByComparator(a.wohnungsstatus, b.wohnungsstatus),
      undefined
    );
    this.tableSortModel.addColumn(
      'administrativeNummer',
      (a, b) => this.comparatorService.orderByComparator(a.administrativeNummer, b.administrativeNummer),
      undefined
    );
    this.tableSortModel.addColumn('stockwerk', (a, b) => this.comparatorService.stockwerkComparator(a.stockwerk, b.stockwerk), undefined);
    this.tableSortModel.addColumn(
      'lageAufStockwerk',
      (a, b) => this.comparatorService.orderByComparator(a.lageAufStockwerk, b.lageAufStockwerk),
      undefined
    );
  }

  @Input()
  set listLoader(value: ListLoader<GwrWohnungListEntry>) {
    if (!value) {
      return;
    }
    value.applySortModel(this.tableSortModel);
    this._listLoader = value;
  }

  get listLoader(): ListLoader<GwrWohnungListEntry> {
    return this._listLoader;
  }
}
